import  { useCallback, useState } from 'react';

import { useApi } from '../contexts/ApiContext';

const useVerifyEmail = () => {
    const api = useApi();
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const verifyEmail = useCallback(
        () => {
            if (!success) {
                setLoading(true);
                api.account
                    .verifyEmail()
                    .then(() => {
                        setSuccess(true);
                        setLoading(false);
                    })
                    .catch(() => {
                        setSuccess(false);
                        setError(true);
                        setLoading(false);
                    });
            }
        },
        [api, setSuccess, setLoading, setError],
    );

    return {
        error,
        loading,
        verifyEmail,
        success,
    };
};

export default useVerifyEmail;